import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="p-4">
      <ul className="list-none p-0">
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/">Homepage</Link></li>
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/teacher-dashboard">Teacher Dashboard</Link></li>
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/submission-statistic-dashboard">Submission Statistic Dashboard</Link></li>
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/table-selector">Table Selector</Link></li>
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/admin-dashboard">Admin Dashboard</Link></li>
        <li className="mb-4"><Link className="text-gray-800 hover:text-blue-500" to="/create-exam-dashboard">Create Exam Dashboard</Link></li>
      </ul>
    </div>
  );
};

export default Sidebar;